import { API_AUTH } from "./common";

const DanhSachNhanVienApi = {
  list: ({ search, cuaHang, trangThai, pageIndex, pageSize }) =>
    API_AUTH.get(
      `quanlynhanvien/danh-sach-nhan-vien?search=${search}&cuahang=${cuaHang}&trangThai=${trangThai}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),
  danhsach: ({ email, phone, name, companyId, pageIndex, pageSize }) =>
    API_AUTH.get(
      `quan-ly-tai-khoan/danh-sach-tai-khoan?email=${email}&phone=${phone}&name=${name}&companyId=${companyId}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),
  roles: () => API_AUTH.get(`quanlynhanvien/roles`, {}),

  luuNhanVien: (nhanvien) => {
    return API_AUTH.post("quanlynhanvien/luu-nhan-vien", nhanvien);
  },

  luuQuyenNhanVien: (nhanvien) => {
    return API_AUTH.post("quanlynhanvien/luu-phan-quyen-nhan-vien", nhanvien);
  },

  xoaNhanVien: (nhanVien) => {
    return API_AUTH.post("quanlynhanvien/xoa-nhan-vien", nhanVien);
  },

  capNhatTrangThaiNhanVien: (nhanVien) => {
    return API_AUTH.post(
      "quanlynhanvien/cap-nhat-trang-thai-nhan-vien",
      nhanVien
    );
  },

  danhsachchucnang: () => {
    return API_AUTH.get("quanlynhanvien/danh-sach-chuc-nang", {});
  },
  danhsachquyentheonhom: (role) => {
    return API_AUTH.get(
      `quanlynhanvien/danh-sach-quyen-theo-nhom?role=${role}`
    );
  },

  danhsachquyentheouser: (username) => {
    return API_AUTH.get(
      `quanlynhanvien/danh-sach-quyen-theo-user?username=${username}`
    );
  },

  luuquyentheonhom: (Role, List, CheckAll) => {
    return API_AUTH.post("quanlynhanvien/luu-quyen-theo-nhom", {
      Role,
      List,
      CheckAll,
    });
  },

  luuquyentheouser: (Role, List, userName) => {
    return API_AUTH.post("quanlynhanvien/luu-quyen-user", {
      Role,
      List,
      userName,
    });
  },

  lockNhanVien: (nhanVien) => {
    return API_AUTH.post("quanlynhanvien/lock-nhan-vien", nhanVien);
  },

  unLockNhanVien: (nhanVien) => {
    return API_AUTH.post("quanlynhanvien/unlock-nhan-vien", nhanVien);
  },

  danhsachcapduyettattoan: () => {
    return API_AUTH.get(`quanlynhanvien/danh-sach-cap-duyet-tat-toan`);
  },

  addOrEditNhanVienDuyet: (item) => {
    return API_AUTH.post("quanlynhanvien/cap-nhat-nhan-vien-cho-duyet", item);
  },

  deleteChucVU: (item) => {
    return API_AUTH.post("quanlynhanvien/delete-chuc-vu", item);
  },

  capNhatThuTuCapDuyet: (list) => {
    return API_AUTH.post("quanlynhanvien/cap-nhat-thu-tu-cap-duyet", list);
  },
};

export default DanhSachNhanVienApi;
